import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React from 'react';

import { patientPropType } from 'Shared/types';
import { activityPropType, questionPropType } from '../types';
import AssessmentQuestion from './AssessmentQuestion';

const ChildQuestionStyle = styled.div`
    margin-left: 30px;
`;

const AssessmentQuestionChildren = ({ questionValues, activity, patient, answerId }) => {
    if (!!activity.id && !questionValues?.response) {
        return null;
    }
    const children = questionValues?.children;
    return (children || [])
        .filter((child) => !answerId || child.parentAnswerId === answerId)
        .sort((childA, childB) => childA.attributes.position - childB.attributes.position)
        .map((child) => (
            <ChildQuestionStyle key={child.questionId}>
                <AssessmentQuestion question={child} activity={activity} patient={patient} />
            </ChildQuestionStyle>
        ));
};

AssessmentQuestionChildren.propTypes = {
    questionValues: questionPropType,
    activity: activityPropType.isRequired,
    patient: patientPropType.isRequired,
    answerId: PropTypes.string,
};
AssessmentQuestionChildren.defaultProps = {
    questionValues: null,
    answerId: null,
};

export default AssessmentQuestionChildren;
